import { SignIn } from "@clerk/clerk-react";

/** Standalone sign-in screen. Which methods appear (Google + email code, no
 *  password) is configured in the Clerk Dashboard, not here. */
export default function SignInPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 px-6 bg-surface1">
      <div className="text-center">
        <h1 className="font-display text-3xl mb-2">
          Ciao<span className="text-accent">.</span>
        </h1>
        <p className="text-text-secondary text-sm">Sign in to keep practicing with Elena.</p>
      </div>
      <SignIn
        routing="hash"
        appearance={{
          variables: {
            colorBackground: '#1c1c1e',
            colorInputBackground: '#2c2c2e',
            colorInputText: '#e5e5ea',
            colorText: '#e5e5ea',
            colorTextSecondary: '#a1a1a8',
            colorPrimary: '#4cab72',
            colorNeutral: '#f5f5f7',
            borderRadius: '14px',
            fontFamily: "'Instrument Sans', -apple-system, BlinkMacSystemFont, sans-serif",
          },
          elements: {
            card: { border: '1px solid #3a3a3c', boxShadow: 'none' },
            headerTitle: { display: 'none' },
            headerSubtitle: { display: 'none' },
            footer: { background: '#252528', borderTop: '1px solid #3a3a3c' },
            footerAction: { color: '#a1a1a8' },
            footerActionLink: { color: '#4cab72' },
            dividerLine: { background: '#3a3a3c' },
            dividerText: { color: '#a1a1a8' },
          },
        }}
      />
    </div>
  );
}
